import React, { Component } from "react";
import { Droppable } from "react-beautiful-dnd";
import classNames from "classnames";
import { arrayOf, shape, bool, func, string } from "prop-types";

import DraggableItem from "pages/_components/DraggableItem";

class InnerDraggableColumn extends Component {
    static propTypes = {
        isDragEnabled: bool,
        itemRenderer: func.isRequired,
        items: arrayOf(shape({})).isRequired,
    };

    static defaultProps = {
        isDragEnabled: false,
    };

    shouldComponentUpdate(nextProps) {
        const { items } = this.props;
        return nextProps?.items !== items;
    }

    render() {
        const { isDragEnabled, itemRenderer, items } = this.props;

        return items.map((item, index) => (
            <DraggableItem isDragEnabled={isDragEnabled} item={item} itemRenderer={itemRenderer} key={index?.id} />
        ));
    }
}

class DraggableColumn extends Component {
    static propTypes = {
        columnId: string.isRequired,
        isDragEnabled: bool,
        itemRenderer: func.isRequired,
        items: arrayOf(shape({})).isRequired,
        title: string,
    };

    static defaultProps = {
        isDragEnabled: false,
        title: null,
    };

    render() {
        const { columnId, isDragEnabled } = this.props;

        return (
            <Droppable droppableId={columnId} isDropDisabled={!isDragEnabled}>
                {(provided) => (
                    <div
                        className={classNames({ "draggable-list__item-container": isDragEnabled })}
                        ref={provided.innerRef}
                        {...provided.droppableProps}>
                        <InnerDraggableColumn {...this.props} />
                    </div>
                )}
            </Droppable>
        );
    }
}

export default DraggableColumn;
